import React, { createContext, useState } from 'react'; 

const ManageUserContext = createContext();


const ManageUserProvider = ({ children }) => {

  const [showID,setShowID] = useState(0)
    
  return (
    <ManageUserContext.Provider value={{showID,setShowID}}>
      {children}
    </ManageUserContext.Provider>
  );
};

export {ManageUserContext, ManageUserProvider};
